import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.about": "About",
      "nav.businessAreas": "Business Areas",
      "nav.services": "Services",
      "nav.allServices": "All Services",
      "nav.serviceDetails": "Service Details",
      "nav.faq": "FAQ",
      "nav.exclusive": "Exclusive/Executive",
      "nav.news": "News",
      "nav.contact": "Contact",
      "nav.getStarted": "Get Started",
      "nav.english": "English",
      
      // Common
      "common.readMore": "Read More",
      "common.learnMore": "Learn More",
      "common.contactUs": "Contact Us",
      "common.getInTouch": "Get in Touch",
      "common.backToNews": "Back to News",
      "common.readFullArticle": "Read Full Article",
      "common.viewAll": "View All",
      
      // Home Page
      "home.gateway": "Your Gateway to DRC Business Success",
      "home.title": "Unlock Your Business Potential in the",
      "home.drc": "DRC",
      "home.tagline": "Invest with Confidence, Consult with Excellence",
      "home.exploreOpportunities": "Explore Opportunities",
      "home.trustedPartner": "As your DRC trusted partner, we help you understand the Congolese business culture and establish strategic relationships with the government.",
      "home.whyChoose": "Why Choose OL-CONSULT?",
      "home.expertise": "Local Expertise",
      "home.expertiseDesc": "Deep understanding of DRC business landscape",
      "home.network": "Extensive Network",
      "home.networkDesc": "Strong government and industry connections",
      "home.proven": "Proven Track Record",
      "home.provenDesc": "Successful projects across multiple sectors",
      "home.cobaltReserves": "Global Cobalt Reserves",
      "home.hydroelectric": "Hydroelectric Potential",
      "home.arableLand": "Hectares Arable Land",
      "home.population": "Population",
      "home.cobaltDesc": "DRC holds the majority of world's cobalt",
      "home.hydroDesc": "Untapped renewable energy capacity",
      "home.landDesc": "Vast agricultural opportunities",
      "home.populationDesc": "Growing consumer market",
      "home.ourServices": "Our Services",
      "home.servicesSubtitle": "Comprehensive Business Solutions for the DRC Market",
      "home.mining": "Mining",
      "home.miningDesc": "With vast reserves of copper, cobalt, gold and other valuable minerals, the mining industry offers highly profitable investment opportunities.",
      "home.agriculture": "Agriculture",
      "home.agricultureDesc": "The DRC's fertile land and favorable climate make it an ideal destination for agricultural investments.",
      "home.infrastructure": "Infrastructure",
      "home.infrastructureDesc": "Be part of this transformative journey by investing in road networks, ports, railways, and energy infrastructure.",
      "home.renewableEnergy": "Renewable Energy",
      "home.renewableEnergyDesc": "Embrace the future of energy by investing in renewable sources in the DRC with abundant hydro, solar, and wind resources.",
      "home.telecommunications": "Telecommunications",
      "home.telecommunicationsDesc": "The DRC's telecommunications sector is experiencing rapid growth, driven by increasing mobile penetration and demand for digital services.",
      "home.statistics": "The DRC Opportunity",
      "home.statisticsSubtitle": "A Market of Unprecedented Potential",
      "home.investmentSectors": "Investment Sectors",
      "home.featuredBusinessAreas": "Featured Business Areas",
      "home.discoverOpportunities": "Discover exceptional opportunities across key sectors in the Democratic Republic of Congo",
      "home.viewAllSectors": "View All Sectors",
      "home.whyChooseTitle": "Why Choose OL-CONSULT?",
      "home.whyChooseSubtitle": "Your Success is Our Priority",
      
      // News Page
      "news.title": "Africa Business News",
      "news.subtitle": "Stay informed about the latest developments in African business, economy, and industry",
      "news.latestInsights": "Latest Business Insights",
      "news.filterCategory": "Filter by Category",
      "news.showing": "Showing",
      "news.articles": "articles",
      "news.all": "All",
      "news.featured": "Featured Story",
      "news.latestArticles": "Latest Articles",
      "news.latestDesc": "Discover insights from across Africa and the DRC",
      "news.readTime": "min",
      "news.continueReading": "Continue Reading",
      "news.viewAllArticles": "View All News Articles",
      "news.backToAllNews": "Back to All News",
      "news.writtenBy": "Written by",
      
      // Categories
      "category.mining": "Mining",
      "category.infrastructure": "Infrastructure",
      "category.energy": "Energy",
      "category.technology": "Technology",
      "category.agriculture": "Agriculture",
      "category.economy": "Economy",
      "category.leadership": "Leadership",
      "category.businessexpansion": "Business Expansion",
      "category.realestate": "Real Estate",
      "category.investment": "Investment",
      "category.internationaltrade": "International Trade",
      
      // About Page
      "about.title": "About OL-CONSULT",
      "about.subtitle": "Your Strategic Partner for Business Success in the DRC",
      "about.whoWeAre": "Who We Are",
      "about.whoWeAreDesc": "OL-CONSULT is a premier business consulting firm specializing in facilitating investments and business operations in the Democratic Republic of Congo. With deep local expertise and extensive networks, we bridge the gap between international investors and the DRC market.",
      "about.ourMission": "Our Mission",
      "about.ourMissionDesc": "To empower businesses to unlock the vast potential of the DRC market through strategic guidance, comprehensive support, and unwavering commitment to excellence.",
      "about.ourVision": "Our Vision",
      "about.ourVisionDesc": "To be the leading business consultancy driving sustainable economic growth and prosperity in the DRC through responsible investment and strategic partnerships.",
      "about.ourValues": "Our Values",
      "about.integrity": "Integrity",
      "about.integrityDesc": "We uphold the highest ethical standards in all our business dealings",
      "about.excellence": "Excellence",
      "about.excellenceDesc": "We deliver superior results through expertise and dedication",
      "about.partnership": "Partnership",
      "about.partnershipDesc": "We build lasting relationships based on trust and mutual success",
      "about.innovation": "Innovation",
      "about.innovationDesc": "We embrace creative solutions to complex business challenges",
      "about.ourTeam": "Our Team",
      "about.ourTeamDesc": "Led by experienced professionals with deep understanding of the DRC business landscape",
      "about.yearsExperience": "Years of Experience",
      "about.successfulProjects": "Successful Projects",
      "about.happyClients": "Happy Clients",
      "about.leadership": "Leadership",
      "about.ledBy": "Led by",
      "about.ceoDesc1": "As CEO of OL-CONSULT SARL, CHEKINAH OLIVIER brings extensive experience in DRC business development and international consulting.",
      "about.ceoDesc2": "Under his visionary leadership, OL-CONSULT has become the trusted partner for businesses seeking to invest in the Democratic Republic of Congo, facilitating successful market entry and sustainable growth.",
      "about.ceoDesc3": "His deep understanding of Congolese business culture and strong government relationships enable our clients to navigate the market with confidence and achieve exceptional results.",
      "about.whyChooseTitle": "What Drives Us",
      
      // Services
      "services.title": "Our Services",
      "services.subtitle": "Comprehensive Business Solutions",
      "services.consultation": "Business Consultation",
      "services.consultationDesc": "Strategic guidance for market entry and expansion in the DRC. We provide comprehensive business planning, regulatory compliance support, and strategic partnerships.",
      "services.investment": "Investment Advisory",
      "services.investmentDesc": "Expert analysis of investment opportunities across mining, agriculture, infrastructure, and energy sectors. We conduct due diligence and risk assessment.",
      "services.project": "Project Management",
      "services.projectDesc": "End-to-end project implementation support from feasibility studies to operational launch. We ensure projects are delivered on time and within budget.",
      "services.market": "Market Research",
      "services.marketDesc": "In-depth analysis of DRC market dynamics, consumer behavior, competitive landscape, and regulatory environment.",
      "services.legal": "Legal & Regulatory Support",
      "services.legalDesc": "Navigate DRC's legal and regulatory framework with expert guidance on licensing, permits, and compliance.",
      "services.networking": "Strategic Networking",
      "services.networkingDesc": "Connect with key stakeholders including government officials, industry leaders, and potential partners.",
      "services.feature1_1": "Complete legal documentation",
      "services.feature1_2": "Business registration",
      "services.feature1_3": "Tax ID setup",
      "services.feature1_4": "Bank account assistance",
      "services.feature2_1": "Investment guarantees",
      "services.feature2_2": "Legal compliance",
      "services.feature2_3": "Intellectual property",
      "services.feature2_4": "Risk management",
      "services.feature3_1": "Market analysis",
      "services.feature3_2": "Strategic planning",
      "services.feature3_3": "Financial advisory",
      "services.feature3_4": "Operational support",
      "services.feature4_1": "Market research",
      "services.feature4_2": "Partnership development",
      "services.feature4_3": "Regulatory navigation",
      "services.feature4_4": "Success roadmap",
      "services.customSolution": "Need a Custom Solution?",
      "services.tailoredServices": "We tailor our services to meet your specific business needs",
      "services.contactTeam": "Contact Our Team",
      
      // Service Details
      "serviceDetails.professionalServices": "Professional Services",
      "serviceDetails.title": "Service Details",
      "serviceDetails.heroSubtitle": "Ready to take your business to new heights? Contact us today to learn more about how OL Consult SARL can help you achieve your international business goals.",
      "serviceDetails.ourServices": "Our Services",
      "serviceDetails.elevateYourBusiness": "Elevate Your Business with Professional Consulting Services",
      "serviceDetails.service1": "Business Strategy Development",
      "serviceDetails.service1Desc": "Our business strategy development service helps businesses maximize their potential by creating plans that define objectives, identify resources, and outline actionable steps.",
      "serviceDetails.service2": "Corporate Governance and Compliance",
      "serviceDetails.service2Desc": "Our corporate governance and compliance service provides the expertise and resources needed to ensure efficient business practices and regulatory compliance.",
      "serviceDetails.service3": "Joint Ventures Possibilities",
      "serviceDetails.service3Desc": "We believe so much in the DRC great potential for growth, that's why we are not just attracting investors, but at OL Consult, we are willing to team up with in major projects through our existing investments vehicles as well as our partners.",
      "serviceDetails.service4": "Partnership & Investments",
      "serviceDetails.service4Desc": "Professional services provided to assist businesses or individuals in forming partnerships, seeking investment opportunities, and managing investment.",
      "serviceDetails.service5": "Project Management",
      "serviceDetails.service5Desc": "Our Project Management Services involve the planning, organizing and controlling of resources to achieve specific goals and objectives within a defined timeframe and budget.",
      "serviceDetails.service6": "Business Process Improvement",
      "serviceDetails.service6Desc": "Our business consulting firm provides clients with tailored strategies to optimize their processes, increasing efficiency and reducing cost.",
      "serviceDetails.service7": "Market Research and Analysis",
      "serviceDetails.service7Desc": "Professional market research and analysis to help business consulting firms identify opportunities and develop effective strategies.",
      "serviceDetails.service8": "Human Resources Optimization",
      "serviceDetails.service8Desc": "Our human resources optimization service provides businesses with tailored solutions to maximize their workforce and create successful outcomes.",
      "serviceDetails.service9": "Financial Modeling and Analysis",
      "serviceDetails.service9Desc": "Our financial modeling and analysis service provides businesses with innovative and in-depth analysis of their financial data.",
      "serviceDetails.videoProfile": "VIDEO PROFILE",
      "serviceDetails.seeUsInAction": "See Us in Action",
      "serviceDetails.videoDescription": "At OL Consult SARL, we pride ourselves on our global reach and local business expertise. With a strong presence in key markets around the DRC, we have the knowledge and connections to help your business thrive in local setting.",
      "serviceDetails.videoFooter": "Whether you are looking to establish your company, expand your operation, establish strategic partnerships, or enter the Congolese market, we have the experience and insights to make it happen.",
      "serviceDetails.getStarted": "Get Started Today",
      
      // FAQ
      "faq.badge": "Frequently Asked Questions",
      "faq.title": "FAQ",
      "faq.subtitle": "We're not just consultants; we're your partners in growth. Together, we can transform your business and position you for success in the DRC and beyond.",
      "faq.contentTitle": "Frequently Asked Questions",
      "faq.contentSubtitle": "Find answers to common questions about investing and doing business in the Democratic Republic of Congo",
      "faq.question1": "Why invest in D.R. Congo?",
      "faq.answer1": "Investing in the Democratic Republic of Congo (D.R. Congo) can be a lucrative opportunity for several reasons:\n\n1. Abundant Natural Resources: D.R. Congo is rich in natural resources, including minerals such as cobalt, copper, diamonds, gold, and tin. It has one of the largest reserves of these minerals in the world.\n\n2. Strategic Location: D.R. Congo is strategically located in the heart of Africa, making it a gateway to other African markets.\n\n3. Large Consumer Market: With a population of over 80 million people, D.R. Congo offers a significant consumer market.\n\n4. Infrastructure Development: The government has prioritized infrastructure development, including roads, railways, ports, and energy projects.\n\n5. Economic Reforms: The government has implemented economic reforms to attract foreign investment and improve the business environment.\n\n6. Agricultural Potential: D.R. Congo has vast agricultural potential, with fertile land and favorable climatic conditions.\n\n7. Growing Middle Class: The middle class is expanding, leading to increased consumer spending.\n\n8. Investment Incentives: The government offers various investment incentives, including tax breaks and investment protection guarantees.",
      "faq.question2": "What different reforms have been implemented in D.R.C. to improve the business environment?",
      "faq.answer2": "The Democratic Republic of Congo has implemented several key reforms:\n\n1. Simplification of Administrative Procedures: Streamlining business registration, permits, and licenses.\n\n2. Investment Code: Legal framework offering incentives such as tax breaks and investment protection guarantees.\n\n3. Improving Access to Finance: Promoting banking sector development and microfinance institutions.\n\n4. Infrastructure Development: Construction and rehabilitation of roads, railways, ports, and energy projects.\n\n5. Anti-Corruption Measures: Establishment of anti-corruption agencies and strengthening transparency.\n\n6. Tax Reforms: Simplifying the tax system and providing tax incentives.\n\n7. Public-Private Partnerships (PPPs): Promoting PPPs to attract private investment in infrastructure projects.",
      "faq.question3": "What is the current exchange system in D.R.C.?",
      "faq.answer3": "The currency of the Democratic Republic of Congo is the Congolese franc (CDF). As of October 2023, the exchange rate is approximately 1 USD = 2,000 CDF.\n\nIt's important to note that the exchange system is subject to market forces and can be influenced by various factors such as economic conditions, government policies, and global market trends. We recommend checking with reliable financial institutions for the most up-to-date rates before engaging in currency exchange transactions.",
      "faq.question4": "What guarantees are provided to investments in D.R. Congo?",
      "faq.answer4": "Several guarantees and protections are provided to investments:\n\n1. Constitutionally Protected Rights: Protection of property rights and the right to engage in economic activities.\n\n2. Investment Code: Guarantees equal treatment for domestic and foreign investors, protection against expropriation, and right to repatriate profits.\n\n3. Bilateral Investment Treaties (BITs): Additional protections including protection against unfair treatment and right to international arbitration.\n\n4. Investment Promotion Agency (ANAPI): Assists investors in navigating the investment process.\n\n5. Special Economic Zones (SEZs): Offer tax benefits, simplified procedures, and infrastructure support.\n\n6. Dispute Resolution Mechanisms: Access to domestic courts and international arbitration through ICSID.",
      "faq.question5": "What are the priority sectors of the D.R. Congo?",
      "faq.answer5": "D.R. Congo has identified several priority sectors for investment:\n\n1. Mining and Natural Resources: Copper, cobalt, gold, diamonds, and tin extraction and processing.\n\n2. Agriculture and Agribusiness: Crop production, livestock farming, agro-processing, and agricultural infrastructure.\n\n3. Energy and Power: Hydropower projects, renewable energy, and power transmission infrastructure.\n\n4. Infrastructure Development: Roads, railways, ports, airports, and telecommunications through PPPs.\n\n5. Manufacturing and Industrialization: Textiles, cement, steel, pharmaceuticals, and consumer goods.\n\n6. Tourism and Hospitality: Eco-tourism, hospitality infrastructure, and travel services.",
      "faq.question6": "What kinds of taxes do companies in D.R.C. pay?",
      "faq.answer6": "Companies in D.R. Congo are subject to various taxes:\n\n1. Corporate Income Tax: 30% standard rate (specific rates for mining and petroleum sectors).\n\n2. Value Added Tax (VAT): 16% standard rate.\n\n3. Payroll Taxes: Social security contributions and pension contributions.\n\n4. Withholding Taxes: On dividends, interest, royalties, and fees for technical services.\n\n5. Property Taxes: Rates vary by location and type of property.\n\n6. Customs Duties: On imported and exported goods.\n\n7. Excise Taxes: On alcohol, tobacco, and petroleum products.\n\n8. Local Taxes: Business license fees and local service taxes.\n\nNote: Tax regulations and rates may change, so consult with tax professionals for current information.",
      
      // Business Areas
      "business.title": "Business Sectors",
      "business.subtitle": "Key Investment Opportunities in the DRC",
      "business.mining": "Mining",
      "business.miningDesc": "Access to world-class mineral resources including cobalt, copper, and gold",
      "business.agriculture": "Agriculture",
      "business.agricultureDesc": "Vast arable land for commercial farming and agribusiness",
      "business.infrastructure": "Infrastructure",
      "business.infrastructureDesc": "Development opportunities in roads, ports, and utilities",
      "business.energy": "Renewable Energy",
      "business.energyDesc": "Massive hydroelectric and solar energy potential",
      "business.telecom": "Telecommunications",
      "business.telecomDesc": "Growing digital infrastructure and connectivity needs",
      "business.inquireNow": "Inquire Now",
      "business.readyToInvest": "Ready to Invest in the DRC?",
      "business.letsDiscuss": "Let's discuss your investment goals and find the perfect opportunity for you",
      "business.contactToday": "Contact Us Today",
      
      // Contact Page
      "contact.title": "Contact Us",
      "contact.subtitle": "Get in Touch with Our Team",
      "contact.name": "Full Name",
      "contact.email": "Email Address",
      "contact.subject": "Subject",
      "contact.message": "Message",
      "contact.send": "Send Message",
      "contact.phone": "Phone",
      "contact.location": "Office Location",
      "contact.hours": "Business Hours",
      "contact.hoursValue": "Mon-Fri: 8:00 AM - 6:00 PM",
      "contact.getInTouch": "Get in Touch",
      "contact.reachOut": "Reach out to us for any inquiries or consultations",
      
      // Policy Page
      "policy.title": "Website Policies",
      "policy.subtitle": "Your privacy and trust are important to us. Learn about how we protect your information and our terms of service.",
      "policy.privacy": "Privacy Policy",
      "policy.terms": "Terms of Service",
      "policy.cookies": "Cookie Policy",
      "policy.lastUpdated": "Last updated",
      "policy.introduction": "Introduction",
      "policy.contactUs": "Contact Us",
      
      // Footer
      "footer.companyDesc": "Your trusted partner for business success in the Democratic Republic of Congo.",
      "footer.quickLinks": "Quick Links",
      "footer.businessSectors": "Business Sectors",
      "footer.contactUs": "Contact Us",
      "footer.email": "Email",
      "footer.allRights": "All rights reserved.",
      "footer.excellence": "Excellence in Business Consulting • Democratic Republic of Congo",
      "footer.privacyPolicies": "Privacy & Policies",
      
      // AI Assistant
      "ai.greeting": "Hello! I'm your OL-CONSULT AI Assistant. How can I help you today?",
      "ai.startConversation": "Start Conversation",
      "ai.listening": "Listening...",
      "ai.mute": "Mute",
      "ai.thinking": "Thinking...",
      "ai.minimize": "Minimize",
      "ai.voiceAssistant": "AI Voice Assistant"
    }
  },
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.about": "À Propos",
      "nav.businessAreas": "Secteurs d'Activité",
      "nav.services": "Services",
      "nav.allServices": "Tous les Services",
      "nav.serviceDetails": "Détails des Services",
      "nav.faq": "FAQ",
      "nav.exclusive": "Exclusif/Exécutif",
      "nav.news": "Actualités",
      "nav.contact": "Contact",
      "nav.getStarted": "Commencer",
      "nav.english": "Anglais",
      
      // Common
      "common.readMore": "Lire Plus",
      "common.learnMore": "En Savoir Plus",
      "common.contactUs": "Nous Contacter",
      "common.getInTouch": "Entrer en Contact",
      "common.backToNews": "Retour aux Actualités",
      "common.readFullArticle": "Lire l'Article Complet",
      "common.viewAll": "Voir Tout",
      
      // Home Page
      "home.gateway": "Votre Porte d'Entrée vers le Succès Commercial en RDC",
      "home.title": "Libérez Votre Potentiel Commercial en",
      "home.drc": "RDC",
      "home.tagline": "Investissez avec Confiance, Consultez avec Excellence",
      "home.exploreOpportunities": "Explorer les Opportunités",
      "home.trustedPartner": "En tant que votre partenaire de confiance en RDC, nous vous aidons à comprendre la culture commerciale congolaise et à établir des relations stratégiques avec le gouvernement.",
      "home.whyChoose": "Pourquoi Choisir OL-CONSULT?",
      "home.expertise": "Expertise Locale",
      "home.expertiseDesc": "Compréhension approfondie du paysage commercial de la RDC",
      "home.network": "Réseau Étendu",
      "home.networkDesc": "Solides connexions gouvernementales et industrielles",
      "home.proven": "Historique Éprouvé",
      "home.provenDesc": "Projets réussis dans plusieurs secteurs",
      "home.cobaltReserves": "Réserves Mondiales de Cobalt",
      "home.hydroelectric": "Potentiel Hydroélectrique",
      "home.arableLand": "Hectares de Terres Arables",
      "home.population": "Population",
      "home.cobaltDesc": "La RDC détient la majorité du cobalt mondial",
      "home.hydroDesc": "Capacité d'énergie renouvelable inexploitée",
      "home.landDesc": "Vastes opportunités agricoles",
      "home.populationDesc": "Marché de consommation en croissance",
      "home.ourServices": "Nos Services",
      "home.servicesSubtitle": "Solutions Commerciales Complètes pour le Marché de la RDC",
      "home.mining": "Mines",
      "home.miningDesc": "Avec de vastes réserves de cuivre, cobalt, or et autres minéraux précieux, l'industrie minière offre des opportunités d'investissement très rentables.",
      "home.agriculture": "Agriculture",
      "home.agricultureDesc": "Les terres fertiles et le climat favorable de la RDC en font une destination idéale pour les investissements agricoles.",
      "home.infrastructure": "Infrastructure",
      "home.infrastructureDesc": "Participez à cette transformation en investissant dans les réseaux routiers, les ports, les chemins de fer et l'infrastructure énergétique.",
      "home.renewableEnergy": "Énergie Renouvelable",
      "home.renewableEnergyDesc": "Adoptez l'avenir de l'énergie en investissant dans les sources renouvelables en RDC avec d'abondantes ressources hydroélectriques, solaires et éoliennes.",
      "home.telecommunications": "Télécommunications",
      "home.telecommunicationsDesc": "Le secteur des télécommunications de la RDC connaît une croissance rapide, stimulée par la pénétration mobile croissante et la demande de services numériques.",
      "home.statistics": "L'Opportunité RDC",
      "home.statisticsSubtitle": "Un Marché au Potentiel Sans Précédent",
      "home.investmentSectors": "Secteurs d'Investissement",
      "home.featuredBusinessAreas": "Secteurs d'Activité en Vedette",
      "home.discoverOpportunities": "Découvrez des opportunités exceptionnelles dans les secteurs clés de la République Démocratique du Congo",
      "home.viewAllSectors": "Voir Tous les Secteurs",
      "home.whyChooseTitle": "Pourquoi Choisir OL-CONSULT?",
      "home.whyChooseSubtitle": "Votre Succès est Notre Priorité",
      
      // News Page
      "news.title": "Actualités Commerciales Africaines",
      "news.subtitle": "Restez informé des derniers développements en matière d'affaires, d'économie et d'industrie africaines",
      "news.latestInsights": "Dernières Informations Commerciales",
      "news.filterCategory": "Filtrer par Catégorie",
      "news.showing": "Affichage de",
      "news.articles": "articles",
      "news.all": "Tous",
      "news.featured": "Article en Vedette",
      "news.latestArticles": "Derniers Articles",
      "news.latestDesc": "Découvrez des informations de toute l'Afrique et de la RDC",
      "news.readTime": "min",
      "news.continueReading": "Continuer la Lecture",
      "news.viewAllArticles": "Voir Tous les Articles",
      "news.backToAllNews": "Retour à Toutes les Actualités",
      "news.writtenBy": "Écrit par",
      
      // Categories
      "category.mining": "Mines",
      "category.infrastructure": "Infrastructure",
      "category.energy": "Énergie",
      "category.technology": "Technologie",
      "category.agriculture": "Agriculture",
      "category.economy": "Économie",
      "category.leadership": "Leadership",
      "category.businessexpansion": "Expansion Commerciale",
      "category.realestate": "Immobilier",
      "category.investment": "Investissement",
      "category.internationaltrade": "Commerce International",
      
      // About Page
      "about.title": "À Propos d'OL-CONSULT",
      "about.subtitle": "Votre Partenaire Stratégique pour le Succès Commercial en RDC",
      "about.whoWeAre": "Qui Nous Sommes",
      "about.whoWeAreDesc": "OL-CONSULT est une société de conseil aux entreprises de premier plan spécialisée dans la facilitation des investissements et des opérations commerciales en République Démocratique du Congo. Avec une expertise locale approfondie et des réseaux étendus, nous comblons le fossé entre les investisseurs internationaux et le marché de la RDC.",
      "about.ourMission": "Notre Mission",
      "about.ourMissionDesc": "Permettre aux entreprises de libérer le vaste potentiel du marché de la RDC grâce à des conseils stratégiques, un soutien complet et un engagement inébranlable envers l'excellence.",
      "about.ourVision": "Notre Vision",
      "about.ourVisionDesc": "Être le cabinet de conseil leader qui stimule la croissance économique durable et la prospérité en RDC grâce à des investissements responsables et des partenariats stratégiques.",
      "about.ourValues": "Nos Valeurs",
      "about.integrity": "Intégrité",
      "about.integrityDesc": "Nous respectons les normes éthiques les plus élevées dans toutes nos transactions commerciales",
      "about.excellence": "Excellence",
      "about.excellenceDesc": "Nous obtenons des résultats supérieurs grâce à notre expertise et notre dévouement",
      "about.partnership": "Partenariat",
      "about.partnershipDesc": "Nous construisons des relations durables basées sur la confiance et le succès mutuel",
      "about.innovation": "Innovation",
      "about.innovationDesc": "Nous adoptons des solutions créatives aux défis commerciaux complexes",
      "about.ourTeam": "Notre Équipe",
      "about.ourTeamDesc": "Dirigée par des professionnels expérimentés ayant une compréhension approfondie du paysage commercial de la RDC",
      "about.yearsExperience": "Années d'Expérience",
      "about.successfulProjects": "Projets Réussis",
      "about.happyClients": "Clients Satisfaits",
      "about.leadership": "Leadership",
      "about.ledBy": "Dirigé par",
      "about.ceoDesc1": "En tant que PDG d'OL-CONSULT SARL, CHEKINAH OLIVIER apporte une vaste expérience dans le développement commercial en RDC et le conseil international.",
      "about.ceoDesc2": "Sous son leadership visionnaire, OL-CONSULT est devenu le partenaire de confiance pour les entreprises cherchant à investir en République Démocratique du Congo, facilitant l'entrée sur le marché et la croissance durable.",
      "about.ceoDesc3": "Sa compréhension approfondie de la culture commerciale congolaise et ses solides relations gouvernementales permettent à nos clients de naviguer sur le marché avec confiance et d'obtenir des résultats exceptionnels.",
      "about.whyChooseTitle": "Ce qui nous motive",
      
      // Services
      "services.title": "Nos Services",
      "services.subtitle": "Solutions Commerciales Complètes",
      "services.consultation": "Consultation Commerciale",
      "services.consultationDesc": "Conseils stratégiques pour l'entrée et l'expansion sur le marché de la RDC. Nous fournissons une planification commerciale complète, un soutien à la conformité réglementaire et des partenariats stratégiques.",
      "services.investment": "Conseil en Investissement",
      "services.investmentDesc": "Analyse experte des opportunités d'investissement dans les secteurs minier, agricole, des infrastructures et de l'énergie. Nous effectuons la diligence raisonnable et l'évaluation des risques.",
      "services.project": "Gestion de Projet",
      "services.projectDesc": "Support de mise en œuvre de projet de bout en bout, des études de faisabilité au lancement opérationnel. Nous nous assurons que les projets sont livrés dans les délais et le budget.",
      "services.market": "Étude de Marché",
      "services.marketDesc": "Analyse approfondie de la dynamique du marché de la RDC, du comportement des consommateurs, du paysage concurrentiel et de l'environnement réglementaire.",
      "services.legal": "Support Juridique et Réglementaire",
      "services.legalDesc": "Naviguez dans le cadre juridique et réglementaire de la RDC avec des conseils d'experts sur les licences, permis et la conformité.",
      "services.networking": "Réseautage Stratégique",
      "services.networkingDesc": "Connectez-vous avec les parties prenantes clés, notamment les responsables gouvernementaux, les leaders de l'industrie et les partenaires potentiels.",
      "services.feature1_1": "Documentation juridique complète",
      "services.feature1_2": "Enregistrement d'entreprise",
      "services.feature1_3": "Configuration du numéro fiscal",
      "services.feature1_4": "Assistance pour compte bancaire",
      "services.feature2_1": "Garanties d'investissement",
      "services.feature2_2": "Conformité légale",
      "services.feature2_3": "Propriété intellectuelle",
      "services.feature2_4": "Gestion des risques",
      "services.feature3_1": "Analyse de marché",
      "services.feature3_2": "Planification stratégique",
      "services.feature3_3": "Conseil financier",
      "services.feature3_4": "Support opérationnel",
      "services.feature4_1": "Recherche de marché",
      "services.feature4_2": "Développement de partenariats",
      "services.feature4_3": "Navigation réglementaire",
      "services.feature4_4": "Feuille de route vers le succès",
      "services.customSolution": "Besoin d'une Solution Personnalisée?",
      "services.tailoredServices": "Nous adaptons nos services pour répondre à vos besoins commerciaux spécifiques",
      "services.contactTeam": "Contactez Notre Équipe",
      
      // Service Details
      "serviceDetails.professionalServices": "Services Professionnels",
      "serviceDetails.title": "Détails des Services",
      "serviceDetails.heroSubtitle": "Prêt à faire passer votre entreprise à un niveau supérieur? Contactez-nous aujourd'hui pour en savoir plus sur la façon dont OL Consult SARL peut vous aider à atteindre vos objectifs commerciaux internationaux.",
      "serviceDetails.ourServices": "Nos Services",
      "serviceDetails.elevateYourBusiness": "Élevez Votre Entreprise avec des Services de Conseil Professionnels",
      "serviceDetails.service1": "Développement de Stratégie Commerciale",
      "serviceDetails.service1Desc": "Notre service de développement de stratégie commerciale aide les entreprises à maximiser leur potentiel en créant des plans qui définissent les objectifs, identifient les ressources et décrivent les étapes concrètes.",
      "serviceDetails.service2": "Gouvernance d'Entreprise et Conformité",
      "serviceDetails.service2Desc": "Notre service de gouvernance d'entreprise et de conformité fournit l'expertise et les ressources nécessaires pour assurer des pratiques commerciales efficaces et la conformité réglementaire.",
      "serviceDetails.service3": "Possibilités de Coentreprises",
      "serviceDetails.service3Desc": "Nous croyons tellement au grand potentiel de croissance de la RDC que nous n'attirons pas seulement des investisseurs, mais chez OL Consult, nous sommes prêts à nous associer à de grands projets par le biais de nos véhicules d'investissement existants ainsi que de nos partenaires.",
      "serviceDetails.service4": "Partenariats et Investissements",
      "serviceDetails.service4Desc": "Services professionnels fournis pour aider les entreprises ou les particuliers à former des partenariats, à rechercher des opportunités d'investissement et à gérer les investissements.",
      "serviceDetails.service5": "Gestion de Projet",
      "serviceDetails.service5Desc": "Nos services de gestion de projet impliquent la planification, l'organisation et le contrôle des ressources pour atteindre des objectifs spécifiques dans un délai et un budget définis.",
      "serviceDetails.service6": "Amélioration des Processus Commerciaux",
      "serviceDetails.service6Desc": "Notre cabinet de conseil en affaires fournit aux clients des stratégies sur mesure pour optimiser leurs processus, augmenter l'efficacité et réduire les coûts.",
      "serviceDetails.service7": "Recherche et Analyse de Marché",
      "serviceDetails.service7Desc": "Recherche et analyse de marché professionnelles pour aider les cabinets de conseil en affaires à identifier les opportunités et à développer des stratégies efficaces.",
      "serviceDetails.service8": "Optimisation des Ressources Humaines",
      "serviceDetails.service8Desc": "Notre service d'optimisation des ressources humaines offre aux entreprises des solutions sur mesure pour maximiser leur main-d'œuvre et créer des résultats réussis.",
      "serviceDetails.service9": "Modélisation et Analyse Financière",
      "serviceDetails.service9Desc": "Notre service de modélisation et d'analyse financière fournit aux entreprises une analyse innovante et approfondie de leurs données financières.",
      "serviceDetails.videoProfile": "PROFIL VIDÉO",
      "serviceDetails.seeUsInAction": "Voyez-Nous en Action",
      "serviceDetails.videoDescription": "Chez OL Consult SARL, nous sommes fiers de notre portée mondiale et de notre expertise commerciale locale. Avec une forte présence sur les marchés clés de la RDC, nous avons les connaissances et les connexions pour aider votre entreprise à prospérer dans un cadre local.",
      "serviceDetails.videoFooter": "Que vous cherchiez à établir votre entreprise, à développer vos opérations, à établir des partenariats stratégiques ou à entrer sur le marché congolais, nous avons l'expérience et les connaissances pour y parvenir.",
      "serviceDetails.getStarted": "Commencez Aujourd'hui",
      
      // FAQ
      "faq.badge": "Questions Fréquemment Posées",
      "faq.title": "FAQ",
      "faq.subtitle": "Nous ne sommes pas seulement des consultants; nous sommes vos partenaires de croissance. Ensemble, nous pouvons transformer votre entreprise et vous positionner pour le succès en RDC et au-delà.",
      "faq.contentTitle": "Questions Fréquemment Posées",
      "faq.contentSubtitle": "Trouvez des réponses aux questions courantes sur l'investissement et les affaires en République Démocratique du Congo",
      "faq.question1": "Pourquoi investir en RDC?",
      "faq.answer1": "Investir en République Démocratique du Congo (RDC) peut être une opportunité lucrative pour plusieurs raisons:\n\n1. Ressources Naturelles Abondantes: La RDC est riche en ressources naturelles, notamment des minéraux tels que le cobalt, le cuivre, les diamants, l'or et l'étain. Elle possède l'une des plus grandes réserves de ces minéraux au monde.\n\n2. Emplacement Stratégique: La RDC est stratégiquement située au cœur de l'Afrique, ce qui en fait une porte d'entrée vers d'autres marchés africains.\n\n3. Grand Marché de Consommation: Avec une population de plus de 80 millions de personnes, la RDC offre un marché de consommation important.\n\n4. Développement des Infrastructures: Le gouvernement a donné la priorité au développement des infrastructures, notamment les routes, les chemins de fer, les ports et les projets énergétiques.\n\n5. Réformes Économiques: Le gouvernement a mis en œuvre des réformes économiques pour attirer les investissements étrangers et améliorer l'environnement des affaires.\n\n6. Potentiel Agricole: La RDC a un vaste potentiel agricole, avec des terres fertiles et des conditions climatiques favorables.\n\n7. Classe Moyenne Croissante: La classe moyenne est en expansion, ce qui entraîne une augmentation des dépenses de consommation.\n\n8. Incitations à l'Investissement: Le gouvernement offre diverses incitations à l'investissement, notamment des allégements fiscaux et des garanties de protection des investissements.",
      "faq.question2": "Quelles réformes ont été mises en œuvre en RDC pour améliorer l'environnement des affaires?",
      "faq.answer2": "La République Démocratique du Congo a mis en œuvre plusieurs réformes clés:\n\n1. Simplification des Procédures Administratives: Rationalisation de l'enregistrement des entreprises, des permis et des licences.\n\n2. Code des Investissements: Cadre juridique offrant des incitations telles que des allégements fiscaux et des garanties de protection des investissements.\n\n3. Amélioration de l'Accès au Financement: Promotion du développement du secteur bancaire et des institutions de microfinance.\n\n4. Développement des Infrastructures: Construction et réhabilitation des routes, chemins de fer, ports et projets énergétiques.\n\n5. Mesures Anti-Corruption: Création d'agences anti-corruption et renforcement de la transparence.\n\n6. Réformes Fiscales: Simplification du système fiscal et offre d'incitations fiscales.\n\n7. Partenariats Public-Privé (PPP): Promotion des PPP pour attirer les investissements privés dans les projets d'infrastructure.",
      "faq.question3": "Quel est le système de change actuel en RDC?",
      "faq.answer3": "La monnaie de la République Démocratique du Congo est le franc congolais (CDF). En octobre 2023, le taux de change est d'environ 1 USD = 2 000 CDF.\n\nIl est important de noter que le système de change est soumis aux forces du marché et peut être influencé par divers facteurs tels que les conditions économiques, les politiques gouvernementales et les tendances du marché mondial. Nous recommandons de vérifier auprès d'institutions financières fiables pour obtenir les taux les plus récents avant d'effectuer des transactions de change.",
      "faq.question4": "Quelles garanties sont fournies aux investissements en RDC?",
      "faq.answer4": "Plusieurs garanties et protections sont fournies aux investissements:\n\n1. Droits Constitutionnellement Protégés: Protection des droits de propriété et du droit d'exercer des activités économiques.\n\n2. Code des Investissements: Garantit un traitement égal pour les investisseurs nationaux et étrangers, protection contre l'expropriation et droit de rapatrier les profits.\n\n3. Traités Bilatéraux d'Investissement (TBI): Protections supplémentaires incluant la protection contre le traitement injuste et le droit à l'arbitrage international.\n\n4. Agence de Promotion des Investissements (ANAPI): Aide les investisseurs à naviguer dans le processus d'investissement.\n\n5. Zones Économiques Spéciales (ZES): Offrent des avantages fiscaux, des procédures simplifiées et un soutien en infrastructure.\n\n6. Mécanismes de Règlement des Différends: Accès aux tribunaux nationaux et à l'arbitrage international via le CIRDI.",
      "faq.question5": "Quels sont les secteurs prioritaires de la RDC?",
      "faq.answer5": "La RDC a identifié plusieurs secteurs prioritaires pour l'investissement:\n\n1. Mines et Ressources Naturelles: Extraction et traitement du cuivre, cobalt, or, diamants et étain.\n\n2. Agriculture et Agro-Industrie: Production agricole, élevage, transformation agro-alimentaire et infrastructure agricole.\n\n3. Énergie et Électricité: Projets hydroélectriques, énergies renouvelables et infrastructure de transmission d'électricité.\n\n4. Développement des Infrastructures: Routes, chemins de fer, ports, aéroports et télécommunications via les PPP.\n\n5. Fabrication et Industrialisation: Textiles, ciment, acier, produits pharmaceutiques et biens de consommation.\n\n6. Tourisme et Hôtellerie: Écotourisme, infrastructure hôtelière et services de voyage.",
      "faq.question6": "Quels types de taxes les entreprises en RDC paient-elles?",
      "faq.answer6": "Les entreprises en RDC sont soumises à diverses taxes:\n\n1. Impôt sur les Sociétés: Taux standard de 30% (taux spécifiques pour les secteurs minier et pétrolier).\n\n2. Taxe sur la Valeur Ajoutée (TVA): Taux standard de 16%.\n\n3. Taxes sur les Salaires: Cotisations de sécurité sociale et cotisations de retraite.\n\n4. Retenues à la Source: Sur les dividendes, intérêts, redevances et frais pour services techniques.\n\n5. Taxes Foncières: Les taux varient selon l'emplacement et le type de propriété.\n\n6. Droits de Douane: Sur les marchandises importées et exportées.\n\n7. Taxes d'Accise: Sur l'alcool, le tabac et les produits pétroliers.\n\n8. Taxes Locales: Frais de licence commerciale et taxes de services locaux.\n\nRemarque: Les réglementations et taux fiscaux peuvent changer, consultez donc des professionnels fiscaux pour obtenir des informations à jour.",
      
      // Business Areas
      "business.title": "Secteurs d'Activité",
      "business.subtitle": "Opportunités d'Investissement Clés en RDC",
      "business.mining": "Mines",
      "business.miningDesc": "Accès aux ressources minérales de classe mondiale incluant cobalt, cuivre et or",
      "business.agriculture": "Agriculture",
      "business.agricultureDesc": "Vastes terres arables pour l'agriculture commerciale et l'agro-industrie",
      "business.infrastructure": "Infrastructure",
      "business.infrastructureDesc": "Opportunités de développement dans les routes, ports et services publics",
      "business.energy": "Énergie Renouvelable",
      "business.energyDesc": "Énorme potentiel hydroélectrique et solaire",
      "business.telecom": "Télécommunications",
      "business.telecomDesc": "Infrastructure numérique en croissance et besoins en connectivité",
      "business.inquireNow": "Se Renseigner Maintenant",
      "business.readyToInvest": "Prêt à Investir en RDC?",
      "business.letsDiscuss": "Discutons de vos objectifs d'investissement et trouvons l'opportunité parfaite pour vous",
      "business.contactToday": "Contactez-Nous Aujourd'hui",
      
      // Contact Page
      "contact.title": "Contactez-Nous",
      "contact.subtitle": "Entrez en Contact avec Notre Équipe",
      "contact.name": "Nom Complet",
      "contact.email": "Adresse Email",
      "contact.subject": "Sujet",
      "contact.message": "Message",
      "contact.send": "Envoyer le Message",
      "contact.phone": "Téléphone",
      "contact.location": "Localisation du Bureau",
      "contact.hours": "Heures d'Ouverture",
      "contact.hoursValue": "Lun-Ven: 8h00 - 18h00",
      "contact.getInTouch": "Entrer en Contact",
      "contact.reachOut": "Contactez-nous pour toute demande de renseignements ou consultation",
      
      // Policy Page
      "policy.title": "Politiques du Site Web",
      "policy.subtitle": "Votre vie privée et votre confiance sont importantes pour nous. Découvrez comment nous protégeons vos informations et nos conditions de service.",
      "policy.privacy": "Politique de Confidentialité",
      "policy.terms": "Conditions d'Utilisation",
      "policy.cookies": "Politique de Cookies",
      "policy.lastUpdated": "Dernière mise à jour",
      "policy.introduction": "Introduction",
      "policy.contactUs": "Contactez-Nous",
      
      // Footer
      "footer.companyDesc": "Votre partenaire de confiance pour le succès commercial en République Démocratique du Congo.",
      "footer.quickLinks": "Liens Rapides",
      "footer.businessSectors": "Secteurs d'Activité",
      "footer.contactUs": "Contactez-Nous",
      "footer.email": "Email",
      "footer.allRights": "Tous droits réservés.",
      "footer.excellence": "Excellence en Conseil d'Affaires • République Démocratique du Congo",
      "footer.privacyPolicies": "Confidentialité et Politiques",
      
      // AI Assistant
      "ai.greeting": "Bonjour! Je suis votre assistant IA OL-CONSULT. Comment puis-je vous aider aujourd'hui?",
      "ai.startConversation": "Démarrer la Conversation",
      "ai.listening": "Écoute...",
      "ai.mute": "Muet",
      "ai.thinking": "Réflexion...",
      "ai.minimize": "Minimiser",
      "ai.voiceAssistant": "Assistant Vocal IA"
    }
  },
  zh: {
    translation: {
      // Navigation
      "nav.home": "首页",
      "nav.about": "关于我们",
      "nav.businessAreas": "业务领域",
      "nav.services": "服务",
      "nav.allServices": "所有服务",
      "nav.serviceDetails": "服务详情",
      "nav.faq": "常见问题",
      "nav.exclusive": "专属/行政",
      "nav.news": "新闻",
      "nav.contact": "联系方式",
      "nav.getStarted": "开始",
      "nav.english": "英语",
      
      // Common
      "common.readMore": "阅读更多",
      "common.learnMore": "了解更多",
      "common.contactUs": "联系我们",
      "common.getInTouch": "取得联系",
      "common.backToNews": "返回新闻",
      "common.readFullArticle": "阅读完整文章",
      "common.viewAll": "查看全部",
      
      // Home Page
      "home.gateway": "您通往刚果民主共和国商业成功的门户",
      "home.title": "释放您在",
      "home.drc": "刚果民主共和国的商业潜力",
      "home.tagline": "充满信心地投资，卓越地咨询",
      "home.exploreOpportunities": "探索机会",
      "home.trustedPartner": "作为您在刚果民主共和国值得信赖的合作伙伴，我们帮助您了解刚果商业文化，并与政府建立战略关系。",
      "home.whyChoose": "为什么选择OL-CONSULT？",
      "home.expertise": "本地专业知识",
      "home.expertiseDesc": "深入了解刚果民主共和国商业环境",
      "home.network": "广泛的网络",
      "home.networkDesc": "强大的政府和行业联系",
      "home.proven": "经过验证的记录",
      "home.provenDesc": "在多个领域成功的项目",
      "home.cobaltReserves": "全球钴储备",
      "home.hydroelectric": "水电潜力",
      "home.arableLand": "公顷可耕地",
      "home.population": "人口",
      "home.cobaltDesc": "刚果民主共和国拥有世界上大部分的钴",
      "home.hydroDesc": "未开发的可再生能源能力",
      "home.landDesc": "广阔的农业机会",
      "home.populationDesc": "不断增长的消费市场",
      "home.ourServices": "我们的服务",
      "home.servicesSubtitle": "针对刚果民主共和国市场的综合商业解决方案",
      "home.mining": "采矿",
      "home.miningDesc": "凭借铜、钴、黄金和其他贵重矿产的巨大储量，采矿业提供高利润的投资机会。",
      "home.agriculture": "农业",
      "home.agricultureDesc": "刚果民主共和国肥沃的土地和有利的气候使其成为农业投资的理想目的地。",
      "home.infrastructure": "基础设施",
      "home.infrastructureDesc": "通过投资道路网络、港口、铁路和能源基础设施，参与这一变革之旅。",
      "home.renewableEnergy": "可再生能源",
      "home.renewableEnergyDesc": "通过投资刚果民主共和国丰富的水力、太阳能和风能资源，拥抱能源的未来。",
      "home.telecommunications": "电信",
      "home.telecommunicationsDesc": "刚果民主共和国的电信业正在快速增长，由移动普及率的提高和对数字服务的需求推动。",
      "home.statistics": "刚果民主共和国的机遇",
      "home.statisticsSubtitle": "一个具有空前潜力的市场",
      "home.investmentSectors": "投资领域",
      "home.featuredBusinessAreas": "特色业务领域",
      "home.discoverOpportunities": "发现刚果民主共和国关键领域的卓越机会",
      "home.viewAllSectors": "查看所有领域",
      "home.whyChooseTitle": "为什么选择OL-CONSULT？",
      "home.whyChooseSubtitle": "您的成功是我们的优先事项",
      
      // News Page
      "news.title": "非洲商业新闻",
      "news.subtitle": "及时了解非洲商业、经济和工业的最新发展",
      "news.latestInsights": "最新商业见解",
      "news.filterCategory": "按类别筛选",
      "news.showing": "显示",
      "news.articles": "篇文章",
      "news.all": "全部",
      "news.featured": "特色故事",
      "news.latestArticles": "最新文章",
      "news.latestDesc": "发现来自非洲和刚果民主共和国的见解",
      "news.readTime": "分钟",
      "news.continueReading": "继续阅读",
      "news.viewAllArticles": "查看所有新闻文章",
      "news.backToAllNews": "返回所有新闻",
      "news.writtenBy": "作者",
      
      // Categories
      "category.mining": "采矿",
      "category.infrastructure": "基础设施",
      "category.energy": "能源",
      "category.technology": "技术",
      "category.agriculture": "农业",
      "category.economy": "经济",
      "category.leadership": "领导力",
      "category.businessexpansion": "业务扩展",
      "category.realestate": "房地产",
      "category.investment": "投资",
      "category.internationaltrade": "国际贸易",
      
      // About Page
      "about.title": "关于OL-CONSULT",
      "about.subtitle": "您在刚果民主共和国商业成功的战略合作伙伴",
      "about.whoWeAre": "我们是谁",
      "about.whoWeAreDesc": "OL-CONSULT是一家专门促进刚果民主共和国投资和商业运营的顶级商业咨询公司。凭借深厚的本地专业知识和广泛的网络，我们在国际投资者和刚果民主共和国市场之间架起桥梁。",
      "about.ourMission": "我们的使命",
      "about.ourMissionDesc": "通过战略指导、全面支持和对卓越的坚定承诺，赋予企业释放刚果民主共和国市场巨大潜力的能力。",
      "about.ourVision": "我们的愿景",
      "about.ourVisionDesc": "成为通过负责任的投资和战略伙伴关系推动刚果民主共和国可持续经济增长和繁荣的领先商业咨询公司。",
      "about.ourValues": "我们的价值观",
      "about.integrity": "诚信",
      "about.integrityDesc": "我们在所有商业交易中坚持最高的道德标准",
      "about.excellence": "卓越",
      "about.excellenceDesc": "我们通过专业知识和奉献精神取得卓越成果",
      "about.partnership": "合作伙伴关系",
      "about.partnershipDesc": "我们建立基于信任和共同成功的持久关系",
      "about.innovation": "创新",
      "about.innovationDesc": "我们拥抱创造性解决方案来应对复杂的商业挑战",
      "about.ourTeam": "我们的团队",
      "about.ourTeamDesc": "由对刚果民主共和国商业环境有深刻理解的经验丰富的专业人士领导",
      "about.yearsExperience": "年经验",
      "about.successfulProjects": "成功项目",
      "about.happyClients": "满意客户",
      "about.leadership": "领导力",
      "about.ledBy": "领导者",
      "about.ceoDesc1": "作为OL-CONSULT SARL的首席执行官，CHEKINAH OLIVIER在刚果民主共和国的商业发展和国际咨询方面拥有丰富的经验。",
      "about.ceoDesc2": "在他富有远见的领导下，OL-CONSULT已成为寻求在刚果民主共和国投资的企业值得信赖的合作伙伴，促进成功的市场进入和可持续增长。",
      "about.ceoDesc3": "他对刚果商业文化的深刻理解和强大的政府关系使我们的客户能够充满信心地驾驭市场并取得卓越成果。",
      "about.whyChooseTitle": "我们的驱动力",
      
      // Services
      "services.title": "我们的服务",
      "services.subtitle": "综合商业解决方案",
      "services.consultation": "商业咨询",
      "services.consultationDesc": "刚果民主共和国市场进入和扩展的战略指导。我们提供全面的商业规划、监管合规支持和战略合作伙伴关系。",
      "services.investment": "投资咨询",
      "services.investmentDesc": "对采矿、农业、基础设施和能源领域投资机会的专家分析。我们进行尽职调查和风险评估。",
      "services.project": "项目管理",
      "services.projectDesc": "从可行性研究到运营启动的端到端项目实施支持。我们确保项目按时按预算交付。",
      "services.market": "市场研究",
      "services.marketDesc": "深入分析刚果民主共和国市场动态、消费者行为、竞争格局和监管环境。",
      "services.legal": "法律和监管支持",
      "services.legalDesc": "在许可、许可证和合规方面的专家指导下，驾驭刚果民主共和国的法律和监管框架。",
      "services.networking": "战略网络",
      "services.networkingDesc": "与包括政府官员、行业领导者和潜在合作伙伴在内的关键利益相关者建立联系。",
      "services.feature1_1": "完整的法律文件",
      "services.feature1_2": "企业注册",
      "services.feature1_3": "税号设置",
      "services.feature1_4": "银行账户协助",
      "services.feature2_1": "投资担保",
      "services.feature2_2": "法律合规",
      "services.feature2_3": "知识产权",
      "services.feature2_4": "风险管理",
      "services.feature3_1": "市场分析",
      "services.feature3_2": "战略规划",
      "services.feature3_3": "财务咨询",
      "services.feature3_4": "运营支持",
      "services.feature4_1": "市场研究",
      "services.feature4_2": "合作伙伴发展",
      "services.feature4_3": "监管导航",
      "services.feature4_4": "成功路线图",
      "services.customSolution": "需要定制解决方案？",
      "services.tailoredServices": "我们量身定制服务以满足您的特定业务需求",
      "services.contactTeam": "联系我们的团队",
      
      // Service Details
      "serviceDetails.professionalServices": "专业服务",
      "serviceDetails.title": "服务详情",
      "serviceDetails.heroSubtitle": "准备将您的业务提升到新的高度？立即联系我们，了解更多关于 OL Consult SARL 如何帮助您实现国际业务目标的信息。",
      "serviceDetails.ourServices": "我们的服务",
      "serviceDetails.elevateYourBusiness": "通过专业咨询服务提升您的业务",
      "serviceDetails.service1": "业务战略发展",
      "serviceDetails.service1Desc": "我们的业务战略发展服务通过创建定义目标、识别资源和概述可行步骤的计划，帮助企业最大化其潜力。",
      "serviceDetails.service2": "公司治理与合规",
      "serviceDetails.service2Desc": "我们的公司治理和合规服务提供确保有效业务实践和监管合规所需的专业知识和资源。",
      "serviceDetails.service3": "合资企业可能性",
      "serviceDetails.service3Desc": "我们非常相信刚果民主共和国的巨大增长潜力，这就是为什么我们不仅吸引投资者，而且在 OL Consult，我们愿意通过我们现有的投资工具以及我们的合作伙伴参与重大项目。",
      "serviceDetails.service4": "合作伙伴关系与投资",
      "serviceDetails.service4Desc": "提供专业服务，协助企业或个人建立合作伙伴关系、寻求投资机会和管理投资。",
      "serviceDetails.service5": "项目管理",
      "serviceDetails.service5Desc": "我们的项目管理服务涉及规划、组织和控制资源，以在规定的时间范围和预算内实现特定目标。",
      "serviceDetails.service6": "业务流程改进",
      "serviceDetails.service6Desc": "我们的商业咨询公司为客户提供量身定制的策略，以优化其流程、提高效率和降低成本。",
      "serviceDetails.service7": "市场研究与分析",
      "serviceDetails.service7Desc": "专业的市场研究和分析，帮助商业咨询公司识别机会并制定有效策略。",
      "serviceDetails.service8": "人力资源优化",
      "serviceDetails.service8Desc": "我们的人力资源优化服务为企业提供量身定制的解决方案，以最大化其劳动力并创造成功的结果。",
      "serviceDetails.service9": "财务建模与分析",
      "serviceDetails.service9Desc": "我们的财务建模和分析服务为企业提供创新和深入的财务数据分析。",
      "serviceDetails.videoProfile": "视频简介",
      "serviceDetails.seeUsInAction": "查看我们的实际运作",
      "serviceDetails.videoDescription": "在 OL Consult SARL，我们为我们的全球影响力和当地业务专业知识感到自豪。凭借在刚果民主共和国关键市场的强大存在，我们拥有帮助您的业务在当地环境中蓬勃发展的知识和联系。",
      "serviceDetails.videoFooter": "无论您是想建立公司、扩大业务、建立战略合作伙伴关系，还是进入刚果市场，我们都有经验和见解来实现这一目标。",
      "serviceDetails.getStarted": "今天开始",
      
      // FAQ
      "faq.badge": "常见问题",
      "faq.title": "常见问题",
      "faq.subtitle": "我们不仅仅是顾问；我们是您成长的合作伙伴。我们可以共同转变您的业务，并使您在刚果民主共和国及其他地区取得成功。",
      "faq.contentTitle": "常见问题",
      "faq.contentSubtitle": "查找有关在刚果民主共和国投资和开展业务的常见问题的答案",
      "faq.question1": "为什么要在刚果民主共和国投资？",
      "faq.answer1": "由于以下几个原因，在刚果民主共和国（DRC）投资可能是一个有利可图的机会：\n\n1. 丰富的自然资源：刚果民主共和国拥有丰富的自然资源，包括钴、铜、钻石、黄金和锡等矿物。它拥有世界上最大的这些矿物储量之一。\n\n2. 战略位置：刚果民主共和国位于非洲中心的战略位置，使其成为通往其他非洲市场的门户。\n\n3. 庞大的消费市场：刚果民主共和国拥有超过8000万人口，提供了重要的消费市场。\n\n4. 基础设施发展：政府优先发展基础设施，包括道路、铁路、港口和能源项目。\n\n5. 经济改革：政府实施了经济改革，以吸引外国投资并改善商业环境。\n\n6. 农业潜力：刚果民主共和国拥有巨大的农业潜力，拥有肥沃的土地和有利的气候条件。\n\n7. 不断增长的中产阶级：中产阶级正在扩大，导致消费支出增加。\n\n8. 投资激励：政府提供各种投资激励措施，包括税收减免和投资保护担保。",
      "faq.question2": "刚果民主共和国实施了哪些改革以改善商业环境？",
      "faq.answer2": "刚果民主共和国实施了几项关键改革：\n\n1. 简化行政程序：简化企业注册、许可证和执照。\n\n2. 投资法：提供激励措施的法律框架，如税收减免和投资保护担保。\n\n3. 改善融资渠道：促进银行业发展和小额信贷机构。\n\n4. 基础设施发展：道路、铁路、港口和能源项目的建设和修复。\n\n5. 反腐败措施：建立反腐败机构并加强透明度。\n\n6. 税收改革：简化税收制度并提供税收激励。\n\n7. 公私合作伙伴关系（PPP）：促进PPP以吸引私人投资基础设施项目。",
      "faq.question3": "刚果民主共和国目前的汇率制度是什么？",
      "faq.answer3": "刚果民主共和国的货币是刚果法郎（CDF）。截至2023年10月，汇率约为1美元 = 2,000刚果法郎。\n\n重要的是要注意，汇率制度受市场力量影响，可能受经济条件、政府政策和全球市场趋势等各种因素的影响。我们建议在进行货币兑换交易之前，向可靠的金融机构查询最新汇率。",
      "faq.question4": "在刚果民主共和国的投资提供哪些担保？",
      "faq.answer4": "为投资提供了几项担保和保护：\n\n1. 宪法保护的权利：保护财产权和从事经济活动的权利。\n\n2. 投资法：保证国内和外国投资者享有平等待遇、免于征收的保护以及利润汇回权。\n\n3. 双边投资条约（BIT）：额外的保护，包括免受不公平待遇的保护和国际仲裁权。\n\n4. 投资促进机构（ANAPI）：协助投资者进行投资流程。\n\n5. 经济特区（SEZ）：提供税收优惠、简化程序和基础设施支持。\n\n6. 争议解决机制：通过ICSID访问国内法院和国际仲裁。",
      "faq.question5": "刚果民主共和国的优先领域是什么？",
      "faq.answer5": "刚果民主共和国已确定了几个投资优先领域：\n\n1. 采矿和自然资源：铜、钴、金、钻石和锡的开采和加工。\n\n2. 农业和农业综合企业：作物生产、畜牧业、农产品加工和农业基础设施。\n\n3. 能源和电力：水电项目、可再生能源和电力传输基础设施。\n\n4. 基础设施发展：通过PPP进行道路、铁路、港口、机场和电信。\n\n5. 制造业和工业化：纺织品、水泥、钢铁、药品和消费品。\n\n6. 旅游和酒店业：生态旅游、酒店基础设施和旅行服务。",
      "faq.question6": "刚果民主共和国的公司需要缴纳哪些税？",
      "faq.answer6": "刚果民主共和国的公司需要缴纳各种税收：\n\n1. 企业所得税：标准税率为30%（采矿和石油部门有特定税率）。\n\n2. 增值税（VAT）：标准税率为16%。\n\n3. 工资税：社会保障缴款和养老金缴款。\n\n4. 预扣税：对股息、利息、特许权使用费和技术服务费。\n\n5. 财产税：税率因地点和财产类型而异。\n\n6. 关税：对进出口商品。\n\n7. 消费税：对酒精、烟草和石油产品。\n\n8. 地方税：营业执照费和地方服务税。\n\n注意：税收法规和税率可能会更改，因此请咨询税务专业人员以获取最新信息。",
      
      // Business Areas
      "business.title": "业务领域",
      "business.subtitle": "刚果民主共和国的关键投资机会",
      "business.mining": "采矿",
      "business.miningDesc": "获得世界级矿产资源，包括钴、铜和金",
      "business.agriculture": "农业",
      "business.agricultureDesc": "用于商业农业和农业综合企业的广阔可耕地",
      "business.infrastructure": "基础设施",
      "business.infrastructureDesc": "道路、港口和公用事业的发展机会",
      "business.energy": "可再生能源",
      "business.energyDesc": "巨大的水电和太阳能潜力",
      "business.telecom": "电信",
      "business.telecomDesc": "不断增长的数字基础设施和连接需求",
      "business.inquireNow": "立即咨询",
      "business.readyToInvest": "准备投资刚果民主共和国？",
      "business.letsDiscuss": "让我们讨论您的投资目标，为您找到完美的机会",
      "business.contactToday": "今天联系我们",
      
      // Contact Page
      "contact.title": "联系我们",
      "contact.subtitle": "与我们的团队取得联系",
      "contact.name": "全名",
      "contact.email": "电子邮件地址",
      "contact.subject": "主题",
      "contact.message": "消息",
      "contact.send": "发送消息",
      "contact.phone": "电话",
      "contact.location": "办公地点",
      "contact.hours": "营业时间",
      "contact.hoursValue": "周一至周五：上午8:00 - 下午6:00",
      "contact.getInTouch": "取得联系",
      "contact.reachOut": "如有任何查询或咨询，请与我们联系",
      
      // Policy Page
      "policy.title": "网站政策",
      "policy.subtitle": "您的隐私和信任对我们很重要。了解我们如何保护您的信息以及我们的服务条款。",
      "policy.privacy": "隐私政策",
      "policy.terms": "服务条款",
      "policy.cookies": "Cookie政策",
      "policy.lastUpdated": "最后更新",
      "policy.introduction": "介绍",
      "policy.contactUs": "联系我们",
      
      // Footer
      "footer.companyDesc": "您在刚果民主共和国取得商业成功的可信赖合作伙伴。",
      "footer.quickLinks": "快速链接",
      "footer.businessSectors": "业务领域",
      "footer.contactUs": "联系我们",
      "footer.email": "电子邮件",
      "footer.allRights": "保留所有权利。",
      "footer.excellence": "商业咨询卓越 • 刚果民主共和国",
      "footer.privacyPolicies": "隐私和政策",
      
      // AI Assistant
      "ai.greeting": "您好！我是您的OL-CONSULT AI助手。今天我能为您做什么？",
      "ai.startConversation": "开始对话",
      "ai.listening": "正在听...",
      "ai.mute": "静音",
      "ai.thinking": "思考中...",
      "ai.minimize": "最小化",
      "ai.voiceAssistant": "AI语音助手"
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
